import Marionette from "backbone.marionette";
import Moment from "moment";
import navBarTpl from "views/navbar/navbarView.ejs";
import SideBar from "views/navbar/sidebarView.js";

// import navbarCSS from "views/navbar/navbar.css";

import S from "session/session.js";
import T from "session/token.js";

var refreshIntervalId;
var recalculateAmorts;

export default Marionette.LayoutView.extend({
    initialize: function() { 
        this.listenTo(S.mApp, "startChecking", this.startChecking); // Start checking if theres a PDF report pending 
        this.listenTo(S.mApp, "recalculateAmortizaciones", this.startCheckingAmortizaciones); //Listen for recalculating               
    },
    template: navBarTpl,
    render: function() {
        this.$el.html(this.template(S.userInfo));        
        this.checkPDF();
    },
    onShow: function() {                
        this.sidebar.show(new SideBar());
    },
    events: {
        "click #logout": "logout",
        "click #backButton": "goBack",
        "click #generatedPDF": "downloadPDF",
    },    
    goBack: function() {
        if($("body").hasClass("autoCollapsed")){
            $("body").removeClass("sidebar-collapse autoCollapsed");
        }
        $("#backButton").addClass("hidden");
        window.history.back();
    },
    logout: function() {
        T.deleteToken();
        window.top.location = "";
    },
    checkPDF: function(){
        // Check for pending PDFs
        $.ajax({
            url:'api/activity/index.php?user=' + S.userInfo.attributes.id,
            method:'GET',            
            success: function(response)
            {                
                if(response == "FOUND"){
                    // Show download button
                    $("#generatedPDF").removeClass("hidden");
                    $("#generatingPDF").addClass("hidden"); 
                    // Stop for checking                    
                    if(refreshIntervalId != "undefined") clearInterval(refreshIntervalId);
                } else if (response == "PARTS") {
                    // Show generating button
                    $("#generatedPDF").addClass("hidden");
                    $("#generatingPDF").removeClass("hidden");                      
                    // Continue Checking
                    if(refreshIntervalId != "undefined") { 
                        // Do nothing                        
                    } else {
                        // Start checking
                        thisAlias.startChecking(); 
                    }
                } else {
                    // Hide both
                    $("#generatedPDF").addClass("hidden");
                    $("#generatingPDF").addClass("hidden");
                    // Stop for checking                    
                    if(refreshIntervalId != "undefined") clearInterval(refreshIntervalId);        
                }                
            }
        });
    },
    checkAmortizaciones: function(){
        $.ajax({
            url:'api/goods/amortizaciones.php?instance=' + S.instanceId,
            method:'GET',            
            success: function(response)
            {                
                if(response == "FOUND"){
                    clearInterval(recalculateAmorts);
                    $("#processingAmortizaciones").addClass("hidden");
                }
            }
        });
    },
    startCheckingAmortizaciones: function() {
        $("#processingAmortizaciones").removeClass("hidden");
        var thisAlias = this;
        recalculateAmorts = setInterval(function() {
            thisAlias.checkAmortizaciones();             
        }, 10000);
    },      
    startChecking: function(){
        var thisAlias = this;
        var checkGeneratingPDF = true;
        refreshIntervalId = setInterval(function() {
            thisAlias.checkPDF();             
        }, 10000);
    },
    downloadPDF: function() {
        // Prepare call
        var xhr = new XMLHttpRequest();
        var method, url, data = [], request = {};
        var name = S.userInfo.attributes.id + "_fullreport.pdf";
        var method = "GET";
        var url = 'api/activity/index.php?mode=download&user=' + S.userInfo.attributes.id;        
        xhr.open(method, url, true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function(e) {
            if (this.status == 200) {
                var blob = new Blob([this.response], {
                    type: "application/pdf"
                });
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                
                link.download = S.report + "_" + Moment().format('DD-MM-YYYY') + ".pdf";
                link.click();
                // Hide downloader
                $("#generatedPDF").addClass("hidden");
                // Show PDF export button
                S.mApp.trigger("stopPendingPDF"); 
            }
        };
        xhr.send(JSON.stringify(request));
    },
    regions: {
        "sidebar": "#sidebar"
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/navbar/navbarView.js
// module id = 196
// module chunks = 0